import { GridColDef } from "@mui/x-data-grid";
import DetailButton from "./DetailButton";

export const userColumns: GridColDef[] = [
  {
    field: "",
    renderCell: DetailButton,
    width: 150,
    headerName: "",
    sortable: false,
    filterable: false,
  },
  {
    field: "id",
    minWidth: 150,
    headerName: "Id",
    sortable: false,
    filterable: false,
  },
  {
    field: "logLevel",
    headerName: "Seviye",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "message",
    headerName: "İleti",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "stackTrace",
    headerName: "Kaynak",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "exception",
    headerName: "Hata",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "source",
    headerName: "Kaynak",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "userId",
    headerName: "Kullanıcı Id",
    flex: 1,
    minWidth: 80,
  },
  {
    field: "timestamp",
    headerName: "Tarih",
    type: "dateTime",
    flex: 1,
    minWidth: 180,
    valueGetter: (v, r) => new Date(v),
  },
];
